import React from 'react';
import './contact.css';
import TextField from '@material-ui/core/TextField';
import {Button} from '../About/comman/Button/button';
import {useState} from 'react';
import axios from 'axios';
import {Notification}  from '../notifications';
import {NotificationContainer} from 'react-notifications';
export function Contact(props) {

    const [contactData, setContactData] =  useState({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    
    const handleChange = (event)=> {
        setContactData({...contactData, [event.target.name]: event.target.value})
    };

    const send = () => {
        console.log(contactData); 
        axios.post('http://localhost:5000/posts', contactData)
        .then(res => {
            Notification('contact', 'data sent successfully', 'success' );
        })
        .catch(err => {
            Notification('contact', 'something went wrong', 'danger' );
        })
    }

    return (
        <div className = 'about container'>
        <NotificationContainer/>
            <div className = 'header row'>
                <h2>Contact Me </h2>
            </div>
            <div className = 'row'>
            <form id ='contactus-form'>
                <div className = 'col-lg-5'>
                    <div className = 'row contact-form mb-2'>
                        <h4>Get In Touch </h4>
                    </div>  
                    <div className = 'row mb-5'>
                    <TextField id="outlined-basic" name = 'name' value = {contactData.name} label="Enter your name" variant="outlined" onChange= {(e)=>handleChange(e)} required />
                    </div>
                    <div className = 'row mb-5'>
                    <TextField id="outlined-basic" type = 'email' name = 'email' value = {contactData.email} label="Enter your email" variant="outlined" onChange= {(e)=>handleChange(e)} required/>
                    </div>
                    <div className = 'row mb-5'>
                    <TextField id="outlined-basic" name = 'subject' value = {contactData.subject} label="Enter your subject" variant="outlined" onChange= {(e)=>handleChange(e)} required/>
                    </div>
                    <div className = 'row mb-4'>
                    <TextField id="outlined-basic" 
                      multiline
                      name = 'message'
                      rows={3}
                      rowsMax={4}
                      value = {contactData.message}
                      onChange= {(e)=>handleChange(e)}
                      label="Enter your message" variant="outlined" required/>
                    </div>
                    <div className = 'row'>
                    <div> <Button title = {'Submit'} click = {send}/> </div> 
                    </div>
                </div>
            </form>
                <div className = 'offset-lg-1 col-lg-6 '>
                    <div className = 'contact-info mb-5'>
                        <div className = 'row contact-info-block'>
                            <span className = 'infoblock-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                            </span>                
                        <div className = 'infoblock-content'>
                            <h6>Phone</h6>
                            <p>
                                <a href= '#'>+012-3456-7891 </a>
                            </p>
                            <p>
                                <a href= '#'>+012-3456-7891 </a>
                            </p>
                        </div>
                        </div>
                        <div className = 'row contact-info-block'>
                            <span className = 'infoblock-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>                            </span>                
                        <div className = 'infoblock-content mb-3'>
                            <h6>Email</h6>
                            <p>
                                <a href= '#'>marwaharamneek@gmail.com </a>
                            </p>
                            <p>
                                <a href= '#'>ramneek.marwaha@gmail.com</a>
                            </p>
                        </div>
                        </div>
                        <div className = 'row contact-info-block'>
                            <span className = 'infoblock-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>                            </span>                
                        <div className = 'infoblock-content'>
                            <h6>Address</h6>
                            <p>
                                G 143, first floor,kalkaji,near pnb bank, new delhi
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}